import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { authKey, CatlougeTypeConstants } from "../../core/constants";
import { SearchResponseModel } from '../../views/search/search.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  END_POINT = environment.api_url;
  private httpClient: HttpClient;
  private search_base_url = environment.search_base_url;
  isParentalControlEnabled: string = '';
  constructor(private httpBackend: HttpBackend,private http: HttpClient) {
    this.httpClient = new HttpClient(httpBackend);
  }

  setParentalControl(status:any){
    this.isParentalControlEnabled = status;
    localStorage.setItem('parentControl', this.isParentalControlEnabled);
  }

   parentalControlStatus(){
    let parentControl = localStorage.getItem('parentControl');;
      return parentControl;
    }


searchResults(body: Object = {}) {
  const headers = new HttpHeaders({
    'Authorization': localStorage.getItem('sessionId') || '',
    'Catalogue': CatlougeTypeConstants.catlogue,
    'Content-Type': 'application/json'
  });

  return this.http.post<SearchResponseModel>(
    this.search_base_url,
    body,
    { headers }
  ).pipe(
    catchError(this.formatErrors)
  );
}

  private formatErrors(error: any): Observable<never> {
    // Customize error formatting as needed
    return throwError(() => new Error(error));
  }
}
